const importRecord = {
  state: {
    additional_information: {
      display_name: '',
      first_name: '',
      last_name: '',
      wechatID: '',
      mobile_number: '',
      contact_email: '',
      address: '',
      dob: '',
      gender: '',
      nationality: '',
      race: '',
      weight: '',
      display_lang: ''
    },
    existUser: false,
    gender: ['M', 'F'],
    internal: {
      client_id: '',
      MemberGTLCode: '',
      FamilyGTLCode: '',
      AgentGTLCode: '',
      MemberWIXID: '',
      MemberEmailID: ''
    },
    open_id: '',
    report: [],
    users: [{}],
    search: '',
    selected_user: {
      client_id: ''
    },
    selected_internal: {},
    user_header: [
      {
        text: 'Cliend ID',
        value: 'client_id'
      },
      {
        text: 'Display Name',
        value: 'display_name'
      },
      {
        text: 'First Name',
        value: 'first_name'
      },
      {
        text: 'Last Name',
        value: 'last_name'
      },
      {
        text: 'wechatID',
        value: 'wechatID'
      },
      {
        text: 'Mobile Number',
        value: 'mobile_number'
      },
      {
        text: 'Contact Email',
        value: 'contact_email'
      },
      {
        text: 'Address',
        value: 'address'
      },
      {
        text: 'Dob',
        value: 'dob'
      },
      {
        text: 'Gender',
        value: 'gender'
      },
      {
        text: 'Nnationality',
        value: 'nationality'
      },
      {
        text: 'Race',
        value: 'race'
      },
      {
        text: 'Weight',
        value: 'weight'
      },
      {
        text: 'Display language',
        value: 'display_lang'
      }
    ]
  },
  mutations: {
    addNewReport (state: any, payload: any) {
      state.report.push({
        reportName: payload.reportName,
        salesGTLCode: payload.salesGTLCode,
        report: payload.report
      })
    },
    reSetImportRecord (state: any) {
      state.additional_information = {
        display_name: '',
        first_name: '',
        last_name: '',
        wechatID: '',
        mobile_number: '',
        contact_email: '',
        address: '',
        dob: '',
        gender: '',
        nationality: '',
        race: '',
        weight: '',
        display_lang: ''
      }
      state.internal = {
        client_id: '',
        MemberGTLCode: '',
        FamilyGTLCode: '',
        AgentGTLCode: '',
        MemberWIXID: '',
        MemberEmailID: ''
      }
      state.report = []
    }
  }
}

export default importRecord
